import { faArrowTurnDownRight } from '@fortawesome/pro-regular-svg-icons/faArrowTurnDownRight'
import { Flex } from '@mantine/core'

import { type CoreItemCategory } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { AvatarCategories } from '../AvatarCategories/AvatarCategories'

export type CellActionsProps = {
  item?: CoreItemCategory
}

export function CellCategoryGroup({ item }: CellActionsProps) {
  return (
    <Flex align='center' gap='md' style={{ overflow: 'hidden' }}>
      {item?.parent_id && (
        <Icon color='gray.6' icon={faArrowTurnDownRight} size='xs' />
      )}
      <AvatarCategories item={item} />
      {item?.name}
    </Flex>
  )
}
